import styled from "styled-components";

export const Container = styled.div`
  align-items: center;
  display: flex;
  justify-content: space-between;

  h1 {
    color: ${({ theme }) => theme.colors.gray};
    font-size: 1.2rem;
  }

  .switch-label {
    font-size: 1.4rem;
    font-weight: 700;
    margin-right: 1rem;
  }

  .input-switch {
    height: 100%;
  }
`;
